// shared/StrategyCard.jsx
// Reusable strategy card component for displaying strategic recommendations
// Extracted from CompetitiveAnalysisView.jsx for better reusability

import React from 'react';

/**
 * Strategy card component for displaying strategic recommendations
 * @param {Object} props - Component props
 * @param {Object} props.strategy - Strategy object with strategy, rationale, risk, and impact
 * @returns {JSX.Element} Strategy card component
 */
const StrategyCard = ({ strategy }) => (
    <div className="p-4 bg-gray-50 rounded-lg">
        <div className="flex justify-between items-start mb-2">
            <div className="font-medium">{strategy.strategy || 'Unknown strategy'}</div>
            <div className="text-sm text-gray-600">
                {strategy.risk || 'Risk not specified'}
            </div>
        </div>
        <div className="text-sm text-gray-600 mb-2">
            {strategy.rationale || 'No rationale provided'}
        </div>
        {strategy.impact && (
            <div className="text-sm font-medium text-blue-600">
                Expected Impact: {strategy.impact}
            </div>
        )}
    </div>
);

export default StrategyCard;
